import Vue from "vue";
import Router from "vue-router";
import { certificateRouter } from "../views/certificate/router";
import {
  channelUserCen,
  constantRouterMap,
  accountManagement,
  resourcesManagement,
  manage,
  templ
} from "./routes";
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css"; // Progress 进度条样式
import dayjs from "dayjs";
import Cookies from "js-cookie";
import store from "../store";
import {handleAxiosAndRouterToken, removeAllCookie, toLogin, validateCookieCert} from "../utils/loginUtils";

const whiteList = ["404", "403", "home", "authorize"]; // 不重定向白名单
Vue.use(Router);

let router = new Router({
  mode: "history", //后端支持可开
  // base: '/web/',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    ...constantRouterMap,
    ...channelUserCen,
    ...manage,
    ...templ,
    ...accountManagement,
    ...certificateRouter,
    ...resourcesManagement
  ]
});

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (whiteList.indexOf(to.name) >= 0) {
    // 在免登录白名单，直接进入
    return next();
  }
  if (validateCookieCert()) {
    // 校验token
    await handleAxiosAndRouterToken();
    await store.dispatch("getuser");
  } else {
    removeAllCookie();
    toLogin();
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js